import { useContentContext } from "../../../contexts/ContentContext"
import LayoutDefault from "../../VideoWall/Layouts/LayoutDefault"
import { Footer } from "../Footer"
import { Header } from "../Header"
import { Config } from "./Configurations/Config";
import { Guide } from "./Guide"
import Theme from '../../../styles/Theme/Theme';
// const isVideowall = window.matchMedia(Theme.devices.videowall).matches;

const components = {
    "guide": <Guide />,
    "videowall": <LayoutDefault />,
    "configurations": <Config />
}
export const Home = () => {
    const { actualPage } = useContentContext();

    return(
        <div>
            {/* {!isVideowall ?  <Header/> : null} */}
            {components[actualPage]}
            {/* {!isVideowall ? <Footer/> : null} */}
        </div>
    )
}//Jorge Costa